var _path, _path2, _path3, _path4, _g, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7469 0H38.3798C39.2912 0 40.0001 0.708859 40.0001 1.62025V32.6076C40.0001 33.519 39.2912 34.2278 38.3798 34.2278H11.7469C11.3418 34.2278 10.8355 34.0253 10.5317 33.7215C10.2279 33.4177 10.0254 33.0127 10.0254 32.6076V1.72152C10.0254 1.31645 10.2279 0.911392 10.5317 0.506329C10.8355 0.202532 11.3418 0.101266 11.7469 0Z",
    fill: "#41A5EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 25.7217H10.0254V32.6078C10.0254 33.5192 10.7343 34.228 11.6457 34.228H38.2785C39.1899 34.228 39.8988 33.5192 39.8988 32.6078L40.0001 25.7217Z",
    fill: "#103F91"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 17.1138H40.0001V25.6201H10.0254V17.1138Z",
    fill: "#185ABD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 8.60742H40.0001V17.1137H10.0254V8.60742Z",
    fill: "#2B7CD3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M20.6582 7.08838H11.9494C11.6456 7.08838 11.3418 7.39217 11.3418 7.69597V26.7339C11.3418 27.0377 11.6456 27.3415 11.9494 27.3415H20.6582C21.3671 27.3415 21.8734 26.8352 21.8734 26.1263V8.30357C21.9747 7.5947 21.3671 7.08838 20.6582 7.08838Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.3292 10.228H10.0254V29.8736H18.3292C19.2406 29.8736 19.9494 29.1647 19.9494 28.2533V11.747C19.9494 10.9369 19.2406 10.228 18.3292 10.228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3292 9.11377H10.0254V28.6581H18.3292C19.2406 28.6581 19.9494 27.9492 19.9494 27.0378V10.734C20.0507 9.82263 19.2406 9.11377 18.3292 9.11377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.1507 7.39258H11.5431C11.2394 7.39258 10.9355 7.69637 10.9355 8.00017V27.0381C10.9355 27.3419 11.2394 27.6457 11.5431 27.6457H20.252C20.9609 27.6457 21.4672 27.1394 21.4672 26.4306V8.60777C21.4672 8.00018 20.8596 7.39258 20.1507 7.39258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M20.1524 7.89893H11.4435C11.1397 7.89893 10.8359 8.20272 10.8359 8.50652V27.342C10.8359 27.6458 11.1397 27.9496 11.4435 27.9496H20.1524C20.8613 27.9496 21.3676 27.4432 21.3676 26.7344V9.11412C21.3676 8.50653 20.8613 7.89893 20.1524 7.89893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M18.734 6.48096H10.0251V22.481H9.92383V25.0126C9.92383 25.3164 10.2276 25.6202 10.5314 25.6202L17.5188 24.405C18.2276 24.405 20.0504 23.7974 20.0504 23.1898V7.69615C20.0504 6.98729 19.5441 6.48096 18.734 6.48096C18.8352 6.48096 18.8352 6.48096 18.734 6.48096Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3292 9.62012H10.0254V29.1644H18.3292C19.2406 29.1644 19.9494 28.4556 19.9494 27.5442V11.2404C20.0507 10.329 19.2406 9.62012 18.3292 9.62012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3292 7.89893H10.0254V27.1394H18.3292C19.2406 27.1394 19.9494 26.4306 20.0507 25.6204V25.5192V9.51918C20.0507 8.60779 19.2406 7.89893 18.3292 7.89893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3292 7.89893H10.0254V27.0382H18.3292C19.2406 27.0382 19.9494 26.4306 20.0507 25.5192V9.51918C20.0507 8.60779 19.2406 7.89893 18.3292 7.89893Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M18.3292 8.30371H10.0254V27.9493H18.3292C19.2406 27.9493 19.9494 27.2404 19.9494 26.329V9.92396C20.0507 9.01257 19.2406 8.30371 18.3292 8.30371C18.4305 8.30371 18.4305 8.30371 18.3292 8.30371Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.3292 8.70898H10.0254V28.3546H18.3292C19.2406 28.3546 19.9494 27.6457 19.9494 26.7343V10.3292C20.0507 9.41784 19.3418 8.70898 18.3292 8.70898C18.4305 8.70898 18.4305 8.70898 18.3292 8.70898Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.9493 8.50635H11.2404C10.9366 8.50635 10.6328 8.81015 10.6328 9.11395V26.9367C10.6328 27.2405 10.9366 27.5443 11.2404 27.5443H19.9493C20.6581 27.5443 21.1645 27.038 21.1645 26.3291V9.72154C21.1645 9.01268 20.6581 8.50635 19.9493 8.50635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.0383 8.50635H10.3295C10.2282 8.50635 10.127 8.50635 10.127 8.50635V27.1393C10.2282 27.1393 10.3295 27.1393 10.3295 27.1393H19.0383C19.7472 27.1393 20.2535 26.6329 20.2535 25.9241V9.72154C20.2535 9.01268 19.6459 8.50635 19.0383 8.50635Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M16.8099 7.39258H10.5314C10.2276 7.39258 9.92383 7.69637 9.92383 8.00017V25.823C9.92383 26.1268 10.2276 26.4306 10.5314 26.4306H19.2403C19.9492 26.4306 20.4555 25.9242 20.4555 25.2154V9.21537C20.4555 8.50651 18.734 8.10144 18.5314 7.89891C18.0251 7.59511 17.4175 7.39258 16.8099 7.39258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M19.545 9.41782H10.8361C10.5323 9.41782 10.2285 9.72162 10.2285 10.0254V27.8482C10.2285 28.152 10.5323 28.4558 10.8361 28.4558H19.545C20.2538 28.4558 20.7602 27.9495 20.7602 27.2406V10.633C20.7602 9.92415 20.2538 9.31655 19.545 9.41782Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.734 6.78467H10.0251V22.7847H9.92383V25.3163C9.92383 25.6201 10.2276 25.9239 10.5314 25.9239L17.5188 24.7087C18.2276 24.7087 20.0504 24.1011 20.0504 23.3923V7.99985C20.0504 7.39226 19.4428 6.78467 18.734 6.78467Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.734 7.18994H10.0251V23.0887H9.92383V25.6203C9.92383 25.9241 10.2276 26.2279 10.5314 26.2279L17.5188 25.0127C18.2276 25.0127 20.0504 24.4051 20.0504 23.6963V8.40513C20.0504 7.69627 19.4428 7.18994 18.734 7.18994Z",
    fill: "black"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72152 7.39258H18.3291C19.2405 7.39258 19.9494 8.10144 19.9494 9.01283V25.3166C19.9494 26.228 19.2405 26.9369 18.3291 26.9369H1.72152C1.31645 26.9369 0.911392 26.7344 0.506329 26.4306C0.202532 26.1268 0 25.7217 0 25.3166V9.01283C0.101266 8.10144 0.810124 7.39258 1.72152 7.39258Z",
    fill: "#185ABD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1904 23.2913H12.9625L10.3296 14.8862L7.59544 23.2913H5.36758L2.83594 11.0381H5.0638L6.78531 19.5444L9.41822 11.2406H11.3423L13.8739 19.5444L15.5954 11.0381H17.722L15.1904 23.2913Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.d34102170473d7caffa6930a9b4bef77.svg";
export { ForwardRef as ReactComponent };